.stepper {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 10px;
  min-width: 0;
}

/* Eight-pixel dots, four apart. Each state is a different shape as well as a different fill, so the
   row reads without colour: done is a solid dot, blocked a solid square, in progress a ring with a
   centre, not checked a diamond, and a station still ahead an empty ring. */
.dots {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dot {
  box-sizing: border-box;
  width: 8px;
  height: 8px;
  flex: 0 0 auto;
  border: 1.5px solid var(--line-2);
  border-radius: 50%;
  background: transparent;
}

.dot[data-state="done"] {
  border-color: var(--ok);
  background: var(--ok);
}

.dot[data-state="current"] {
  border-color: var(--accent);
  background: radial-gradient(circle, var(--accent) 35%, transparent 40%);
}

.dot[data-state="blocked"] {
  border-color: var(--crit);
  border-radius: 1px;
  background: var(--crit);
}

.dot[data-state="unknown"] {
  border-color: var(--warn);
  border-radius: 1px;
  background: var(--warn-w);
  transform: rotate(45deg) scale(0.9);
}

.dot[data-state="na"] {
  border-style: dashed;
}

/* The station the filing is at is a little larger than the rest. */
.dot[data-here] {
  width: 10px;
  height: 10px;
}

.text {
  min-width: 0;
  color: var(--ink);
  font-size: var(--t-dense);
  font-weight: 600;
  line-height: 1.3;
}
